import { useLocation } from "react-router-dom";
import dayjs from "dayjs";

import Header from "components/Header";
import { formatNumber } from "helpers/formatNumber";
import MainLayout from "layouts/Main";
import { SubscriptionHistory } from "models/UserSetting";
import styles from "./style.module.scss";

export default function BillingReceipt() {
  const { state } = useLocation();
  const {
    amount,
    created,
    statement_description,
    card: { address_zip, country, last4, type }
  } = state.data as SubscriptionHistory;

  return (
    <MainLayout
      desktopTitle="Billing"
      customHeader={<Header label="View Receipt" />}
      className={styles.billingReceiptContainer}>
      <div className={styles.invoiceCardWrapper}>
        <h3 className={styles.companyName}>ComFreight.com, LLC</h3>

        <address>
          235 East Broadway
          <br />
          Suite 940
          <br />
          Long Beach, CA 90802
          <br />
          US (888) 633-5558
        </address>

        <div className={styles.otherInfo}>
          <h4 className="text-xl">Order Information</h4>
          <div className={styles.billing}>
            <span>Description: {statement_description}</span>
            <p>
              <span className="text-base font-bold">Billing Information</span>
              <br />
              {address_zip}
              <br />
              {country}
              <br />
              {type} XXXX-XXXX-XXXX-{last4}
            </p>
          </div>
        </div>

        <p className={styles.totalAmount}>Total: {formatNumber(amount / 100, 2)}</p>

        <div className={styles.paymentInfo}>
          <h4 className="text-xl">Payment Information</h4>
          <div className={styles.grid}>
            <ul className="grid grid-cols-2">
              <li>Date/Time:</li>
              <li>{dayjs.unix(created).format("MM/DD/YYYY H:mm:ss A UTC")}</li>
            </ul>
            <ul className="grid grid-cols-2">
              <li>Payment Method:</li>
              <li>
                {type} XXXX-XXXX-XXXX-{last4}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
